const platform = require('platform');

$.applyDataMask('.js-mask');

// Select
$('.js-select--default')
    .on('focus', function () {
        $(this).closest('.select__wrapper').addClass('opened');
    })
    .on('change blur', function () {
        $(this).closest('.select__wrapper').removeClass('opened');
    })

// CHECKBOXES
$('.js-checkbox').on('click', (e) => {
    let $checkboxInput = $(e.target),
        $checkboxLabel = $checkboxInput.closest('.checkbox__label');

    $checkboxLabel.toggleClass('checked');
});

$.validator.addMethod('email', function (value, element, param) {
    if (value.length) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(value);
    } else {
        return true;
    }
});

$.validator.addMethod('email-mask', function (value, element, param) {
    if (value.length) {
        const arValue = value.split('@');

        let mask = element.getAttribute('data-email-mask') || '',
            domain;

        if (arValue.length > 1 && mask.length) {
            domain = arValue[1]
            mask = mask.split(',');

            if (mask.indexOf(domain) > 0) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    } else {
        return true;
    }
});

//Очистка формы
global.resetForm = function ($form = $('.js-form:not(.js-form--old)')) {
    $form.each(function (key, form) {
        let $form = $(form);
        var validator = $form.validate();
        validator.resetForm();
        $form.trigger('reset');

        $form.find('input[type=text], input[type=email], input[type=password], input[type=file], select, textarea')
            .val('')
            .removeClass('form__label--success form__label--error')
            .closest('label')
            .removeClass('form__label--focused');

        $form.find('select')
            .trigger('change');

        $form.find('input[type=radio], input[type=checkbox]')
            .prop('checked', false)
            .removeAttr('checked')
            .removeAttr('selected')
            .closest('label')
            .removeClass('form__label--success form__label--error checkbox__label--checked radio__label--checked checked')
            .closest('.checkbox, .radio')
            .removeClass('form__label--success form__label--error');

        $form.find('input[type=submit]').prop('disabled', true).addClass('disabled')

        if ($form.find('.g-recaptcha').length) {
            grecaptcha.reset($form.find('.g-recaptcha').data('grecaptcha-id'));
        }
    });
};

//Валидация формы
global.initValidationForms = function (form = '.js-form:not(.js-form--old)') {
    $(form).each(function (key, form) {
        $(form).validate({
            errorElement: 'span',
            errorClass: 'form__label--error',
            validClass: 'form__label--success',
            submitHandler: function (form, event) {
                if ($(form).parent('.component__search').length) {
                    return false; //prevent send on search field in component
                }
                if ($(form).attr('id') == 'subscribe-form') {
                    let actionPath = $(form).attr('action'),
                        email = $(form).find('[name=email]').val(),
                        langid = $(form).find('[name=langid]').val();
                    location.href = `${actionPath}?${encodeURI(`LANG_ID=${langid}&sf_EMAIL=${email}`)}`;
                    return false;
                }
                if (!$(form).hasClass('js-form--non-ajax')) {
                    event.preventDefault();
                    let $captcha = $(form).find('input[name="captcha_sid"]'),
                        $grecaptcha = $(form).find($('.g-recaptcha')),
                        $submitBtn = $(form).find('input[type=submit]'),
                        $preloader = $(`<div class="form__preloader"><div class="preloader"></div></div>`);

                    function startSend() {
                        $submitBtn
                            .addClass('btn--disabled')
                            .prop('disabled', true);

                        $preloader
                            .appendTo($(form))
                            .velocity('fadeIn');
                    }

                    function endSend() {
                        if ($submitBtn.hasClass('btn--disabled') || $(form).find('.form__preloader').length) {
                            $submitBtn
                                .removeClass('btn--disabled')
                                .prop('disabled', false);
                            $(form).find('.form__preloader')
                                .velocity('fadeOut')
                                .remove();
                        }
                    }

                    startSend();

                    if ($captcha.length) {
                        let csid        = $(form).find('#captcha_sid'),
                            cword       = $(form).find('#captcha_word');

                        $.get(`/ajax/captcha.php?captcha_sid=${csid.val()}&captcha_word=${cword.val()}`, function (response) {
                            if (response.toString() == '0') {
                                showNotyfications('Enter a valid captcha code', {type: 'error'});
                                endSend();
                            } else {
                                postFormData($(form), () => {
                                    endSend();
                                });
                            }

                            /* refresh captcha */
                            reloadCaptcha($(form));
                        });
                    } else if ($grecaptcha.length) {

                        if (grecaptcha && grecaptcha.getResponse($grecaptcha.data('grecaptcha-id')).length == 0) {
                                var showNotyficationsMessage = localize({
                                    en: 'Enter a valid CAPTCHA code',
                                    ru: 'Пожалуйста, введите корректное значение CAPTCHA'
                                });
                                if ($grecaptcha.siblings($('.g-recaptcha__noty')).length) {
                                    $grecaptcha
                                        .siblings($('.g-recaptcha__noty'))
                                        .html(showNotyficationsMessage)
                                        .css('display', 'block');
                                } else {
                                    showNotyfications(showNotyficationsMessage, {type: 'error'});
                                }

                                endSend();
                        } else {
                            postFormData($(form), () => {
                                endSend();
                            });
                        }

                    } else {
                        postFormData($(form), () => {
                            endSend();
                        });
                    }
                } else {
                    if ($(form).valid()) {
                        form.submit();
                    }
                }
                return false;
            },
            invalidHandler: function (form) {},
            errorPlacement: function (error, element) {
                if (element.is('select')) {
                    if (element.siblings('.select2').length) {
                        error.insertAfter(element.siblings('.select2'));
                    } else {
                        error.insertAfter(element.siblings('.select__wrapper'));
                    }
                } else if (element.is(':radio')) {
                    element.closest('.radio').addClass('form__label--error');
                    error.insertAfter(element.closest('.radio'));
                } else if (element.is(':checkbox')) {
                    const $label = element.closest('.checkbox__label')
                    $label.addClass('form__label--error');
                    error.appendTo($label)
                } else if (element.attr('type') === 'file') {
                    element.closest('.form__valid-container').addClass('form__label--error');
                    error.appendTo(element.closest('.form__valid-container'));
                } else {
                    error.insertAfter(element);
                    if ($(element).hasClass('js-mask-phone')) {
                        element.closest('.intl-tel-input').addClass('form__label--error');
                    }
                }
            },
            success: function (element) {}
        });
    });
};

global.postFormData = function(form, callback) {
    let formData = new FormData(form[0]),
        action = form.attr('action') || '/ajax/forms.php',
        notyForm = form.attr('data-noty-container'),
        $notyContent = $('.js-noty-content[data-noty-id="'+notyForm+'"]');

    $.ajax({
        url: action,
        type: 'POST',
        data: formData,
        async: false,
        cache: false,
        contentType: false,
        processData: false,
        success: function(res) {
            let response = JSON.parse(res);
            if (response.success) {
                if ($notyContent.length) {
                    $notyContent
                        .removeClass('.noty-error')
                        .html(response.msg)
                        .css('display', 'block');
                    form.css('display', 'none')
                } else {
                    showNotyfications(response.msg, { type: 'success' });
                }
                resetForm(form);
                callback();
            } else {
                if ($notyContent.length) {
                    $notyContent
                        .html(response.msg)
                        .addClass('noty-error')
                        .css('display', 'block');
                } else {
                    showNotyfications(response.msg, { type: 'error' });
                }

                if (form.find('.g-recaptcha').length) {
                    grecaptcha.reset(form.find('.g-recaptcha').data('grecaptcha-id'));
                }

                callback();
            };
        }
    });
};

global.checkValidtaionEl = function($el) {
    $el.each(function (key, el) {
        let isValid = $el.valid();

        if (isValid) {
            if ($el.hasClass('js-radio')) {
                $el
                    .closest('.radio')
                    .removeClass('form__label--error')
                    .addClass('form__label--success');
            } else if ($el.hasClass('js-checkbox')) {
                $el
                    .closest('.checkbox, .checkbox__label')
                    .removeClass('form__label--error')
                    .addClass('form__label--success');
            } else if ($el.hasClass('js-file-input')) {
                $el
                    .closest('.form__valid-container')
                    .removeClass('form__label--error')
                    .addClass('form__label--success');
            }
            if ($el.hasClass('js-mask-phone')) {
                $el
                    .closest('.intl-tel-input')
                    .removeClass('form__label--error')
                    .addClass('form__label--success');
            }
        } else {
            if ($el.hasClass('js-radio')) {
                $el
                    .closest('.radio')
                    .removeClass('form__label--success')
                    .addClass('form__label--error');
            } else if ($el.hasClass('js-checkbox')) {
                $el
                    .closest('.checkbox, .checkbox__label')
                    .removeClass('form__label--success')
                    .addClass('form__label--error');
            } else if ($el.hasClass('js-file-input')) {
                $el
                    .closest('.form__valid-container')
                    .removeClass('form__label--success')
                    .addClass('form__label--error');
            }
            if ($el.hasClass('js-mask-phone')) {
                $el
                    .closest('.intl-tel-input')
                    .removeClass('form__label--success')
                    .addClass('form__label--error');
            }
        }
    });
}

function reloadCaptcha($form) {
    $.get('/ajax/captcha_reload.php', function (data) {
        $form
            .find('#captcha_sid')
            .val(data);
        $form
            .find('.captcha__img')
            .attr('src', '/bitrix/tools/captcha.php?captcha_sid=' + data);
        $form
            .find('#captcha_word')
            .val('');
    });
}

$(document).on('click', '.js-captcha-reload', function (e) {
    e.preventDefault();
    reloadCaptcha($(this).closest('form'));
});

$(document).on('submit', '.js-form:not(.js-form--old)', function (event) {
    checkValidtaionEl($(this).find('.js-form__el'));
});

$(document).on('change select2:select select2:unselect', '.js-form__el, .js-file-input', function (e) {
    checkValidtaionEl($(this));
});

initValidationForms();

// Добавление и удаление класса disabled для кнопки отправки формы
function removeDisabledClass($form, $element) {
    if ($form.validate().checkForm()) {
        $element.removeClass('disabled').prop('disabled', false);
    } else {
        $element.addClass('disabled').prop('disabled', true);
    }
}

if ($('.js-form:not(.js-form--old)')) {
    let $form = $('.js-form:not(.js-form--old)'),
        $validatingFormInput = $form.find('input[type="text"], input[type="email"], input[type="number"], textarea'),
        $validatingFormEl = $form.find('input[type="file"], input[type="text"], input[type="email"], input[type="number"], textarea, .js-select, .js-select--default, .js-checkbox, .js-radio'),
        $formBtnSubmit = $form.find('.btn[type="submit"]');

    if (!$formBtnSubmit.hasClass('disabled')) {
        $formBtnSubmit.addClass('disabled').prop('disabled', true);
    }

    $form.on('keyup change click select2:select select2:unselect', $validatingFormEl, function () {
        removeDisabledClass($form, $formBtnSubmit);
    });

    $form.on('click', '.file-input__remove', $validatingFormEl, function () {
        removeDisabledClass($form, $formBtnSubmit);
    });
}

global.onloadCallbackCaptcha = function() {
    $('.g-recaptcha').each(function(index, el) {
        $(el).attr('data-grecaptcha-id', index);
        grecaptcha.render(el, {
            'sitekey': $(el).attr('data-sitekey') || '6LccIbUUAAAAAF8vdNRff5gUcIGuh1x90HtUiD_n',
            'theme': $(el).attr('data-theme'),
            'size': $(el).attr('data-size'),
            'tabindex': $(el).attr('data-tabindex'),
            'callback': $(el).attr('data-callback'),
            'expired-callback': $(el).attr('data-expired-callback'),
            'error-callback': $(el).attr('data-error-callback')
        });
    })
};



// WEBPACK FOOTER //
// ./frontend/components/forms/forms.js